import { SearchQueryOrderDirection } from "types/generated";

export const READY_TO_MIGRATE_FILTERS_TYPE = "openTofuMigrationReady";
export const READY_TO_MIGRATE_FILTERS_ORDER_SETTINGS_KEY = "openTofuMigrationReadyFiltersOrder";
export const READY_TO_MIGRATE_TABLE_STORAGE_KEY = "openTofuMigrationReadyTable";
export const READY_TO_MIGRATE_LIMIT_STORAGE_KEY = "openTofuMigrationReadyLimit";

export const READY_TO_MIGRATE_FILTER_VARIABLES = {
  filterType: READY_TO_MIGRATE_FILTERS_TYPE,
  initialSortOption: "name",
  initialSortDirection: SearchQueryOrderDirection.Asc,
};

export const MIGRATE_REFETCH_QUERIES = [
  "GetOpenTofuMigrationCounts",
  "SearchOpenTofuMigrateStacks",
  "SearchOpenTofuMigrateSuggestions",
];
